import { Routes } from '@angular/router';
import { LoginComponent } from './pages/session/login/login.component';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { NotFoundComponent } from './pages/common/not-found/not-found.component';
import { NavLayoutComponent } from './shared/components/layouts/nav-layout/nav-layout.component';
import { FichaClinicaComponent } from './pages/navigate/ficha-clinica/ficha-clinica.component';
import { AnamnesisComponent } from './pages/navigate/ficha-clinica/anamnesis/anamnesis.component';
import { CalendarioAgendamientoComponent } from './pages/navigate/calendario-agendamiento/calendario-agendamiento.component';
import { IngresoNuevaConsultaComponent } from './pages/common/components/nuevo-agendamiento/ingreso-nueva-consulta.component';
import { CrearPasswordComponent } from './pages/session/login/crear-password/crear-password.component';
import { ModalRecuperarPasswordComponent } from './pages/session/modal-recuperar-password/modal-recuperar-password.component';
import { IngresoHoraFechaComponent } from './pages/common/components/nuevo-agendamiento/ingreso-hora-fecha/ingreso-hora-fecha.component';
import { ModalNuevoAgendamientoCreadoComponent } from './shared/components/modal-nuevo-agendamiento-creado/modal-nuevo-agendamiento-creado.component';
import { ModalBloqueoHorarioComponent } from './pages/common/components/bloqueo-horario/modal-bloqueo-horario.component';
import { TemplateCorreoComponent } from './shared/components/template-correo/template-correo.component';
import { HasRoleGuard } from "./shared/guards/has-role/has-role.guard";
import { ValidRoles } from "./shared/enums";
import { MisPacientesComponent } from "./pages/common/components/mis-pacientes/mis-pacientes.component";
import { PacienteComponent } from "./pages/common/components/paciente/paciente.component";
import { authGuard, loginRedirectGuard, medicalCenterGuard } from './shared/guards/auth.guard';
import { MedicalCentersComponent } from './pages/navigate/medical-centers/medical-centers.component';


export enum ROUTES_APP {
  HOME = 'home',
  LOGIN = 'login',
  MEDICAL_CENTERS = 'medical-centers',
  FICHA_CLINICA = 'ficha',
  REGISTRO_CONSULTA = 'registro',
  ANAMNESIS = 'anamnesis',
  CALENDARIO = 'calendario',
  NUEVA_CONSULTA = 'ingreso',
  RECUPERAR_PASSWORD = 'recuperar-pass',
  CREAR_PASSWORD = 'crear-pass',
  SELECT_HORA_FECHA_NUEVA_CONSULTA = 'hora-fecha',
  MODAL_NUEVA_CONSULTA = 'modal-prueba',
  HTML_CORREO = 'prueba_correo',
  BLOQUEO_HORARIO = 'bloqueo-horario',
  TEMPLATE_CORREO = 'correo',
  MIS_PACIENTES = 'mis-pacientes',
  PACIENTE = 'paciente',
}

export const routes: Routes = [
  {
    path: '',
    redirectTo: ROUTES_APP.LOGIN,
    pathMatch: 'full',
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: ROUTES_APP.LOGIN,
        loadComponent: () => LoginComponent,
        canActivate: [loginRedirectGuard],
      },
      {
        path: ROUTES_APP.CREAR_PASSWORD,
        loadComponent: () => CrearPasswordComponent,
      },

      {
        path: ROUTES_APP.RECUPERAR_PASSWORD,
        loadComponent: () => ModalRecuperarPasswordComponent,
      },
    ],
  },
  {
    path: '',
    component: CalendarioAgendamientoComponent,
    canActivate: [authGuard, medicalCenterGuard],
    children: [
      {
        path: ROUTES_APP.CALENDARIO,
        loadComponent: () => CalendarioAgendamientoComponent,
      },
    ],
  },
  {
    path: ROUTES_APP.MIS_PACIENTES,
    loadComponent: () => MisPacientesComponent,
    canActivate: [authGuard, HasRoleGuard, medicalCenterGuard],
    data: {
      roles: [ValidRoles.MEDIC, ValidRoles.MEDICAL_ASSISTANT]
    }
  },
  {
    path: ROUTES_APP.PACIENTE + '/:idPaciente',
    loadComponent: () => PacienteComponent,
    canActivate: [authGuard, HasRoleGuard, medicalCenterGuard],
    data: {
      roles: [ValidRoles.MEDIC, ValidRoles.MEDICAL_ASSISTANT]
    }
  },
  {
    path: ROUTES_APP.NUEVA_CONSULTA + '/:idAgendamiento',
    loadComponent: () => IngresoNuevaConsultaComponent,
    canActivate: [authGuard, medicalCenterGuard],
  },
  {
    path: ROUTES_APP.NUEVA_CONSULTA,
    loadComponent: () => IngresoNuevaConsultaComponent,
    canActivate: [authGuard, medicalCenterGuard],
  },
  {
    path: ROUTES_APP.TEMPLATE_CORREO,
    loadComponent: () => TemplateCorreoComponent,
    canActivate: [authGuard, medicalCenterGuard],
  },
  {
    path: ROUTES_APP.BLOQUEO_HORARIO,
    loadComponent: () => ModalBloqueoHorarioComponent,
    canActivate: [authGuard, medicalCenterGuard],
  },
  {
    path: ROUTES_APP.SELECT_HORA_FECHA_NUEVA_CONSULTA,
    loadComponent: () => IngresoHoraFechaComponent,
    canActivate: [authGuard, medicalCenterGuard],
  },
  {
    path: ROUTES_APP.MODAL_NUEVA_CONSULTA,
    loadComponent: () => ModalNuevoAgendamientoCreadoComponent,
    canActivate: [authGuard, medicalCenterGuard],
  },
  {
    path: ROUTES_APP.MEDICAL_CENTERS,
    loadComponent: () => MedicalCentersComponent,
    canActivate: [authGuard],
  },
  {
    path: '',
    component: NavLayoutComponent,
    canActivate: [authGuard, medicalCenterGuard],
    children: [
      {
        path: ROUTES_APP.FICHA_CLINICA,
        loadComponent: () => FichaClinicaComponent,
        canActivate: [HasRoleGuard],
        data: {
          roles: [ValidRoles.MEDIC, ValidRoles.MEDICAL_ASSISTANT]
        }
      },
      {
        path: ROUTES_APP.ANAMNESIS,
        loadComponent: () =>
          import(
            '../app/pages/navigate/ficha-clinica/anamnesis/anamnesis.component'
          ).then((m) => AnamnesisComponent),
      },
    ],
  },
  {
    path: '**',
    loadComponent: () => NotFoundComponent,
  },
];
